import { combineReducers } from "redux";
import * as auth from "../app/modules/Auth/redux/authReducer";
import * as userManagement from "../app/modules/user_management/redux";
import * as adminManagement from "../app/modules/admin_management/redux";
import * as servicesReducer from "../app/modules/services/redux/servicesReducer";
import * as emailManagement from "../app/modules/email_management/redux";
import * as betManagement from "../app/modules/bet_management/redux";
import * as profile from "../app/modules/profile_settings/redux";
import * as dashboard from "../app/modules/dashboards/redux";
import * as thirdParty from "../app/modules/third_party_services/redux";
import * as notificationManagement from "../app/modules/notification_management/redux";
import * as cms from "../app/modules/cms_pages/redux";
import * as defaultPassword from "../app/modules/default_password/redux";
import snackBarReducer from "../app/modules/snackBar/snackbarReducer";
// import * as feeSettings from "../app/modules/fee_settings /redux";
import * as payment from "../app/modules/payment/redux";
import * as reportsAndAnaytics from "../app/modules/reports_and_analytics/redux";
import * as ticketSupportManagement from "../app/modules/ticketSupportManagement/redux";
import * as teamManagement from "../app/modules/team_management/redux";
import * as faq from "../app/modules/faq_management/redux";
import * as virtualTokenManagement from "../app/modules/virtual_token/redux";
import * as tokenTransaction from "../app/modules/token_transactions/redux";
import * as systemSettingManagement from "../app/modules/system_settings/redux";
import * as commissionHistory from "../app/modules/commission_history/redux";
import * as currencyManagement from "../app/modules/currency/redux";
import * as withdrawalRequest from "../app/modules/withdrawal_management/redux";
import * as referralBonusCoins from "../app/modules/referral_bonus_coins/redux";
import * as promoCodeManagement from "../app/modules/promo_code_management/redux";
export const rootReducer = combineReducers({
  snackBar: snackBarReducer,
  dashboard: dashboard.reducer,
  auth: auth.reducer,
  userManagement: userManagement.reducer,
  adminManagement: adminManagement.reducer,
  emailManagement: emailManagement.reducer,
  notificationManagement: notificationManagement.reducer,
  profile: profile.reducer,
  thirdParty: thirdParty.reducer,
  cms: cms.reducer,
  defaultPassword: defaultPassword.reducer,
  servicesManagement: servicesReducer.reducer,
  betManagement: betManagement.reducer,
  // feeSettings: feeSettings.reducer,
  payment: payment.reducer,
  reportsAndAnaytics: reportsAndAnaytics.reducer,
  ticketSupportManagement: ticketSupportManagement.reducer,
  teamManagement: teamManagement.reducer,
  faq: faq.reducer,
  virtualTokenManagement: virtualTokenManagement.reducer,
  tokenTransaction: tokenTransaction.reducer,
  systemSettingManagement: systemSettingManagement.reducer,
  commissionHistory: commissionHistory.reducer,
  currencyManagement: currencyManagement.reducer,
  withdrawalRequest: withdrawalRequest.reducer,
  referralBonusCoins: referralBonusCoins.referralBonusCoinsReducer,
  promoCodeManagement: promoCodeManagement.reducer,
});
